// تعریف فیلدهای هر نوع txt فرمت
export const TXT_FORMATS = {
  txt1: {
    name: "txt1",
    fields: [
      { key: "personnelId", len: 3 },
      { key: "activityDaily", len: 2 },
      { key: "endOvertime", len: 5 },
      { key: "extraUrbanDailyAssignment", len: 2 },
      { key: "dependentDailyLeave", len: 2 },
      { key: "sickDailyLeave", len: 2 },
      { key: "dependentHourlyLeave", len: 5 },
      { key: "dailyAbsence", len: 2 },
      { key: "fraction", len: 5 },
      { key: "outOvertime", len: 5 },
      { key: "startOvertime", len: 5 },
      { key: "activity", len: 5 },
    ],
    useHeader: true,
  },
  txt2: {
    name: "txt2",
    fields: [
      { key: "personnelId", len: 3 },
      { key: "activityDaily", len: 2 },
      { key: "endOvertime", len: 5 },
      { key: "extraUrbanDailyAssignment", len: 2 },
      { key: "dependentDailyLeave", len: 2 },
      { key: "sickDailyLeave", len: 2 },
      { key: "dependentHourlyLeave", len: 5 },
      { key: "dailyAbsence", len: 2 },
      { key: "fraction", len: 5 },
      { key: "outOvertime", len: 5 },
      { key: "startOvertime", len: 5 },
      { key: "activity", len: 5 },
    ],
    useHeader: true,
  },
  txt3: {
    name: "txt3",
    fields: [
      { key: "personnelId", len: 10 },
      { key: "functionDay", len: 2 },
      { key: "overtime", len: 5 },
      { key: "hourlyAbsence", len: 5 },
      { key: "nightWork", len: 5 },
      { key: "holidayOvertime", len: 5 },
      { key: "dependentDailyLeave", len: 2 },
      { key: "sickDailyLeave", len: 2 },
      { key: "noSalaryDailyLeave", len: 2 },
      { key: "dailyAssignment", len: 2 },
      { key: "dependentHourlyLeave", len: 3 },
      { key: "hourlyAssignment", len: 5 },
    ],
    useFooterItems: true,
  },
  txt4: {
    name: "txt4",
    fields: [
      { key: "personnelId", len: 4, format: "slice4" },
      { key: "dailyActivity", len: 10 },
      { key: "hourlyActivity", len: 6, keepColon: true },
      { key: "workShift", len: 6, keepColon: true },
      { key: "overtime", len: 6, keepColon: true },
      { key: "fridayWork", len: 6, keepColon: true },
      { key: "holidayOverTimeOvertime", len: 6, keepColon: true },
      { key: "delay", len: 6, keepColon: true },
      { key: "dependentLeave", len: 6, keepColon: true },
      { key: "sickLeave", len: 6, keepColon: true },
      { key: "absence", len: 6, keepColon: true },
      { key: "hourlyAssignment", len: 6, keepColon: true },
      { key: "dailyAssignment", len: 2 },
    ],
    separator: ",",
  },
  txt5: {
    name: "txt5",
    fields: [
      { key: "personnelId", len: 5 },
      { key: "dailyActivity", len: 2 },
      { key: "overtime", len: 6, keepColon: true },
      { key: "assignment", len: 2 },
      { key: "sickLeave", len: 2 },
      { key: "noSalaryLeave", len: 2 },
      { key: "delay", len: 6, keepColon: true },
      { key: "hurry", len: 6, keepColon: true },
      { key: "incentiveLeave", len: 2, replaceColon: true },
      { key: "leaveSum", len: 7, keepColon: true },
      { key: "absence", len: 2 },
      { key: "dependentLeave", len: 6, keepColon: true  },
      { key: "dependantDailyLeave", len: 2 }
    ],
    skipLastRow: true,
    separator: ","
  },
  txt6: {
    name: "txt6",
    fields: [
      { key: "personnelId", len: 3 },
      { key: "functionDay", len: 2 },
      { key: "nightWork", len: 2 },
      { key: "holidayWork", len: 2, keepColon: true },
      { key: "fridayWork", len: 2, keepColon: true },
      { key: "shiftWork", len: 2, keepColon: true },
      { key: "overtimeHourly", len: 6, keepColon: true },
      { key: "nightWorkHourly", len: 6 },
      { key: "holidayWorkHourly", len: 6, keepColon: true },
      { key: "activityHourly", len: 6 },
      { key: "delayHourly", len: 6 },
      { key: "shiftOvertimeHourly", len: 6 },
      { key: "invalidActivityHourly", len: 6 },
    ],
    skipLastRow: true,
  },

  txt7: {
    name: "txt7",
    fields: [
      { key: "personnelId", len: 4 },
      { key: "dailyActivity", len: 2 },
      { key: "overtime", len: 5, keepColon: true },
      { key: "delay", len: 5, keepColon: true },
      { key: "hurry", len: 5, keepColon: true },
      { key: "holidayOverTimeOvertime", len: 5, keepColon: true },
      { key: "dependantLeave", len: 2 },
      { key: "hourlyDependantLeave", len: 5, keepColon: true },
    ],
    skipLastRow: true,
    separator: " ",
  },
  txt8: {
    name: "txt8",
    fields: [
      { key: "personnelId", len: 4 },
      { key: "dailyActivity", len: 2 },
      { key: "overtime", len: 5, keepColon: true },
      { key: "delay", len: 5, keepColon: true },
      { key: "hurry", len: 5, keepColon: true },
      { key: "holidayOverTimeOvertime", len: 5, keepColon: true },
      { key: "dependantLeave", len: 2 },
      { key: "hourlyDependantLeave", len: 5, keepColon: true },
    ],
    skipLastRow: true,
  },
};

// تابع برای دریافت فیلدهای مفقود
export const getMissingFields = (format, presentKeys) => {
  const allFields = format.fields.map((f) => f.key);
  return allFields.filter((k) => !presentKeys.includes(k));
};

// تابع برای فرمت کردن مقدار بر اساس تنظیمات
export const formatFieldValue = (
  value,
  fieldConfig,
  modifyItem,
  modifyItemKeepColon,
) => {
  let result = value !== undefined && value !== null ? String(value) : "0";

  // replaceColon فقط برای incentiveLeave
  if (fieldConfig.replaceColon && typeof result === "string") {
    result = result.replace(/:/g, "0");
  }

  // keepColon برای فیلدهای زمانی
  if (
    fieldConfig.keepColon &&
    typeof modifyItemKeepColon === "function" &&
    !fieldConfig.replaceColon
  ) {
    result = modifyItemKeepColon(result);
  } else if (!fieldConfig.replaceColon && typeof modifyItem === "function") {
    result = modifyItem(result);
  }

  // Padding
  if (result.length > fieldConfig.len) {
    result = result.substr(0, fieldConfig.len);
  } else {
    result = result.padStart(fieldConfig.len, "0");
  }

  return result;
};
